<mat-form-field appearance="outline">
  <mat-label>Years</mat-label>
  <mat-select [formControl]="filterControl" multiple>
    @for (year of possibleYears; track year) {
      <mat-option [value]="year">{{year}}</mat-option>
    }
  </mat-select>
</mat-form-field>
